import styled from 'styled-components';

export const Badge = styled.span<{
  $isBasket: boolean;
  $diameter: number;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.$diameter}px;
  height: ${props => props.$diameter}px;
  background: var(--${props => (props.$isBasket ? 'error-600' : 'grey-500')});
  border-radius: var(--radius-fullyrounded);
  color: var(--white);
  font-size: var(--font-size-text-xs);
  font-weight: var(--font-weight-semibold);
`;
